import {
  HTTP_STATUS_CODE_OK,
  LoadingStatus,
  useIsLoggedInToMyRac,
  useSessionIdStorageKey,
  useSetBackdrop,
} from "raci-react-library";
import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { sessionIdAtom } from "../../atoms";
import { ErrorRoute } from "../../routing/routes.config";
import useNavigateToRoute from "../../routing/useNavigateToRoute";
import { useBffApiClient } from "../useApiClient";

export const useCreateSession = () => {
  const client = useBffApiClient();
  const sessionIdStorageKey = useSessionIdStorageKey();
  const setBackdrop = useSetBackdrop();
  const isLoggedIn = useIsLoggedInToMyRac();
  const setSessionId = useSetRecoilState(sessionIdAtom);
  const navigate = useNavigateToRoute();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isCancelled = false;

    const createSession = async () => {
      setIsError(false);

      const hasSessionId = sessionStorage.getItem(sessionIdStorageKey);

      try {
        setBackdrop(true);
        if (!isCancelled && !hasSessionId) {
          if (!isLoggedIn) {
            setIsError(true);
          } else {
            const response = await client.createSession();
            sessionStorage.setItem(sessionIdStorageKey, response.result);
            setSessionId(response.result);
            if (response.status !== HTTP_STATUS_CODE_OK) {
              setIsError(true);
            }
          }
        }
      } catch (e) {
        setIsError(true);
        navigate(ErrorRoute.SystemUnavailable);
      } finally {
        setIsLoading(false);
        setBackdrop(false);
      }
    };

    createSession();

    return () => {
      isCancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client, sessionIdStorageKey]);

  return isLoading ? LoadingStatus.Loading : isError ? LoadingStatus.Error : LoadingStatus.Successful;
};

export default useCreateSession;
